var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBonVoyageArrow(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 91,
    viewBox: "0 0 114 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("foreignObject", {
    x: -123.472,
    y: -124.457,
    width: 361.568,
    height: 339.037
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(62.23px)",
      clipPath: "url(#bgblur_0_1674_1303_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-figma-bg-blur-radius": 124.457,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.116 38.2629L65.8104 2.8183C61.1132 -0.939081 53.5109 -0.939785 48.8131 2.8183L4.50734 38.2629C-0.189836 42.0204 -0.190055 48.1031 4.50734 51.8609L48.8131 87.3054C53.5103 91.0628 61.1126 91.0635 65.8104 87.3054L110.116 51.8609C114.813 48.1033 114.814 42.0206 110.116 38.2629ZM83.0803 36.2511C83.0957 36.2708 83.1107 36.2909 83.133 36.3179C84.1523 37.5518 83.8942 39.572 81.9334 40.4667L70.3807 49.8534C69.6918 50.4131 68.7823 50.6937 67.872 50.6937C64.7773 50.6937 63.167 47.6865 65.3638 45.9015L71.5974 40.8369H41.4703V56.3262C41.4703 57.8814 39.8943 59.1424 37.95 59.1424C36.0057 59.1424 34.4297 57.8814 34.4297 56.3262V38.0207C34.4297 36.4654 36.0057 35.2044 37.95 35.2044H71.9765L65.7429 30.1398C64.379 29.0316 64.3962 27.2486 65.7817 26.1573C67.1669 25.0658 69.3959 25.0797 70.76 26.1881C82.6607 35.8573 82.9046 36.0274 83.0803 36.2511Z",
    fill: "white",
    fillOpacity: 0.66
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_1674_1303_clip_path",
    transform: "translate(123.472 124.457)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.116 38.2629L65.8104 2.8183C61.1132 -0.939081 53.5109 -0.939785 48.8131 2.8183L4.50734 38.2629C-0.189836 42.0204 -0.190055 48.1031 4.50734 51.8609L48.8131 87.3054C53.5103 91.0628 61.1126 91.0635 65.8104 87.3054L110.116 51.8609C114.813 48.1033 114.814 42.0206 110.116 38.2629ZM83.0803 36.2511C83.0957 36.2708 83.1107 36.2909 83.133 36.3179C84.1523 37.5518 83.8942 39.572 81.9334 40.4667L70.3807 49.8534C69.6918 50.4131 68.7823 50.6937 67.872 50.6937C64.7773 50.6937 63.167 47.6865 65.3638 45.9015L71.5974 40.8369H41.4703V56.3262C41.4703 57.8814 39.8943 59.1424 37.95 59.1424C36.0057 59.1424 34.4297 57.8814 34.4297 56.3262V38.0207C34.4297 36.4654 36.0057 35.2044 37.95 35.2044H71.9765L65.7429 30.1398C64.379 29.0316 64.3962 27.2486 65.7817 26.1573C67.1669 25.0658 69.3959 25.0797 70.76 26.1881C82.6607 35.8573 82.9046 36.0274 83.0803 36.2511Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBonVoyageArrow);
export default __webpack_public_path__ + "static/media/bonVoyageArrow.c3320706555e6165011b6eb3762b5411.svg";
export { ForwardRef as ReactComponent };